/*
 * Вход через Keycloak (realm mineflow) — BL-103 этап 1.
 *
 * Новая frontend-система не имеет встроенного generic-OIDC api,
 * поэтому: ApiBlueprint создаёт OAuth2-клиент поверх бэкенд-провайдера
 * `oidc` (@backstage/plugin-auth-backend-module-oidc-provider), а
 * SignInPageBlueprint подменяет стандартную страницу входа. В dev-окружении
 * (auth.environment: development) рядом остаётся гостевой вход.
 */
import {
  ApiBlueprint,
  createApiRef,
  createFrontendModule,
  configApiRef,
  discoveryApiRef,
  oauthRequestApiRef,
} from '@backstage/frontend-plugin-api';
import {
  SignInPageBlueprint,
  type SignInPageProps,
} from '@backstage/plugin-app-react';
import { OAuth2 } from '@backstage/core-app-api';
import { SignInPage } from '@backstage/core-components';
import type {
  BackstageIdentityApi,
  OpenIdConnectApi,
  ProfileInfoApi,
  SessionApi,
} from '@backstage/core-plugin-api';

export const keycloakAuthApiRef = createApiRef<
  OpenIdConnectApi & ProfileInfoApi & BackstageIdentityApi & SessionApi
>({
  id: 'auth.mineflow-keycloak',
});

const keycloakAuthApi = ApiBlueprint.make({
  name: 'keycloak-auth',
  params: define =>
    define({
      api: keycloakAuthApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        oauthRequestApi: oauthRequestApiRef,
        configApi: configApiRef,
      },
      factory: ({ discoveryApi, oauthRequestApi, configApi }) =>
        OAuth2.create({
          configApi,
          discoveryApi,
          oauthRequestApi,
          provider: {
            id: 'oidc',
            title: 'Keycloak',
            icon: () => null,
          },
          environment: configApi.getOptionalString('auth.environment'),
          defaultScopes: ['openid', 'profile', 'email'],
        }),
    }),
});

const signInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => (props: SignInPageProps) => (
      <SignInPage
        {...props}
        auto
        providers={[
          {
            id: 'oidc',
            title: 'Keycloak',
            message: 'Вход учёткой MineFlow (Keycloak, realm mineflow)',
            apiRef: keycloakAuthApiRef,
          },
        ]}
      />
    ),
  },
});

export const authModule = createFrontendModule({
  pluginId: 'app',
  extensions: [keycloakAuthApi, signInPage],
});
